import { Grid, InputLabel, TextField } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { ChangeEvent, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootThunkDispatch, IRootState } from "../../redux/store";
import { infoCatelogType } from "../../interface/form";
import moment from "moment";
import { AttendanceCollectionInfo } from "../../redux/collection/state";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import { axiosGet } from "../../util/axios";
import { OpenSnackBarWithResultFail } from "../../redux/common/snackBar/thunk";
import ReactSelect, { SingleValue } from "react-select";
import { BinInfo } from "../../redux/staticInfo/state";
import { initBinList } from "../../redux/staticInfo/thunk";
import {
  ChangeAttendaceDateTimeThunk,
  changeBinInfoThunk,
  handleCollectionDatethunk,
} from "../../redux/collection/thunk";
import {
  ChangeCleaningAttendaceDateTimeThunk,
  ChangeCleaningDateTimeThunk,
  changeCleaningBinInfoThunk,
  changePeopleCounterNumberThunk,
} from "../../redux/cleaning/thunk";

interface Props {
  mode: infoCatelogType;
}

function EditAttendance(props: Props) {
  const dispatch = useDispatch<IRootThunkDispatch>();

  const { selectedEditattendanceCollection, binInfo } = useSelector(
    (state: IRootState) => state.collectionState
  );

  const { selectedCleaningDetail, binInfo: binCleaningInfo } = useSelector(
    (state: IRootState) => state.cleaningState
  );

  const { originalList } = useSelector(
    (state: IRootState) => state.staticInfoState
  );

  const dataFetchedRef = useRef(false);
  useEffect(() => {
    const controller = new AbortController();
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    if (originalList.length === 0) {
      getBinData();
    } else {
      handleGetValue(originalList);
    }
    return () => {
      controller.abort();
    };
  }, []);

  async function getBinData() {
    dispatch(OpenLoadingBarThunk(true));
    let result = await axiosGet("/api/bin");
    if (result.data.success) {
      dispatch(OpenLoadingBarThunk(false));
      dispatch(initBinList(result.data.binList));
      handleGetValue(result.data.binList);
    } else {
      dispatch(OpenSnackBarWithResultFail("無法下載回收桶資料"));
    }
  }

  function handleSelectedBin(binInfo: SingleValue<BinInfo>) {
    if (props.mode === "Collection") {
      dispatch(changeBinInfoThunk(binInfo));
    } else if (props.mode === "Cleaning") {
      dispatch(changeCleaningBinInfoThunk(binInfo));
    } else {
      return;
    }
  }

  function handleGetValue(binList: BinInfo[]) {
    if (props.mode === "Collection") {
      const defaultValue = (
        selectedEditattendanceCollection as AttendanceCollectionInfo
      ).value;
      const selectedOption = binList?.find(
        (bin) => bin.value === parseInt(defaultValue)
      );
      if (selectedOption) {
        dispatch(changeBinInfoThunk(selectedOption));
      }
      return binInfo;
    }

    return binInfo;
  }
  function handleAttendanceDateChange(date: moment.Moment | null) {
    if (props.mode === "Collection" && date) {
      dispatch(ChangeAttendaceDateTimeThunk(date));
    } else if (props.mode === "Cleaning" && date) {
      const unix = moment(date).local().valueOf();
      
      dispatch(ChangeCleaningAttendaceDateTimeThunk(unix.toString()));
    }
  }

  function handleCollectionDateChange(date: Date) {
    if (props.mode === "Collection" && date) {
      dispatch(handleCollectionDatethunk(date));
    } else if (props.mode === "Cleaning" && date) {
      dispatch(ChangeCleaningDateTimeThunk(date));
    }
  }

  function handleChangePeopleCounter(event:ChangeEvent<HTMLInputElement>){
    const people_counter_number =(event.target.value)
    dispatch(changePeopleCounterNumberThunk(people_counter_number))
    
  }

  return (
    <>
      <Grid>
        <InputLabel htmlFor="enquiry-date-picker">打卡時間</InputLabel>

        {/* <Grid>{moment(parseInt(selectedCleaningDetail?.attendance_date)).format('YYYY-MM-DD HH:mm:ss')}</Grid> */}

        <DateTimePicker
          value={
            props.mode === "Collection"
              ? (selectedEditattendanceCollection as AttendanceCollectionInfo)
                  .attendance_date
              : props.mode === "Cleaning"
              ? // moment(parseInt(selectedCleaningDetail?.attendance_date)).format('YYYY-MM-DD HH:mm:ss')
                selectedCleaningDetail.attendance_date
              : ""
          }
          onChange={(data) => handleAttendanceDateChange(data as moment.Moment)}
          sx={{ width: "auto" }}
          format="YYYY-MM-DD HH:mm"
          timeSteps={{ minutes: 1 }}
          ampm={false}
        />

        <InputLabel htmlFor="enquiry-date-picker">
          {props.mode === "Collection" ? "收集時間" : "完成時間"}
        </InputLabel>

        <DateTimePicker
          value={
            props.mode === "Collection"
              ? (selectedEditattendanceCollection as AttendanceCollectionInfo)
                  .collection_date
              : props.mode === "Cleaning"
              ? selectedCleaningDetail.update_date
              : ""
          }
          onChange={(data) => handleCollectionDateChange(data! as Date)}
          sx={{ width: "auto" }}
          format="YYYY-MM-DD HH:mm"
          timeSteps={{ minutes: 1 }}
          ampm={false}
        />
      </Grid>

      <Grid>
        <Grid>
          <InputLabel id="district-area-id">
            桶號及名稱*（永遠預設為車線的桶名稱）
          </InputLabel>
          <ReactSelect
            options={originalList}
            isSearchable
            menuPlacement="auto"
            menuPosition="fixed"
            value={props.mode === "Collection" ? binInfo : binCleaningInfo}
            onChange={(bin) => handleSelectedBin(bin)}
          />
        </Grid>
      </Grid>

      <Grid>
        <TextField 
        variant="filled" 
        value={selectedCleaningDetail.people_counter_number} 
        type='number'
        label={"人流"}
        onChange={handleChangePeopleCounter}
        
        />
      </Grid>
    </>
  );
}

export default EditAttendance;
